import { Component, ViewChild } from '@angular/core';
import { LoaderService } from './services/loader.service';
import { Subscription } from 'rxjs';

declare var $: any;

@Component({
  selector: 'loader-spinner',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent {
  loaderSubscription: Subscription;

  text: string;

  constructor(private loaderService: LoaderService) {
    this.loaderSubscription = this.loaderService.loaderState.subscribe((state) => {
      if (state.toggle) {
        this.text = state.message;
        $('#modal-spinner').modal('show');
      } else {
        $('#modal-spinner').modal('hide');
      }
    });
  }
}
